import { jsx as _jsx } from "react/jsx-runtime";
import { PostListOrderByEnum } from '@tribeplatform/gql-client/types';
import { MemberPostList } from './MemberPostList';
import { SpacePostList } from './SpacePostList';
export const PostList = ({ memberId, spaceId, tagId, tagSlug, view, hasParent = false, orderBy = PostListOrderByEnum.publishedAt, }) => {
    if (spaceId) {
        return (_jsx(SpacePostList
        // add 'key' prop to force rerender when a space changes
        // otherwise `orderBy` in SpacePostList state is kept from previous render (and previous space)
        , { orderBy: orderBy, spaceId: spaceId, tagId: tagId, tagSlug: tagSlug, view: view }, spaceId));
    }
    return (_jsx(MemberPostList, { hasParent: hasParent, memberId: memberId, view: view }, void 0));
};
//# sourceMappingURL=PostList.js.map